import { buildEnvironmentFilters } from 'src/apps/dashboard/services/queries/dashboard/helpers/environmentFilterBuilder';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import {
	calculateRecentPeriodDates,
	formatDateForGraphQL
} from 'src/common/helpers/DateFormatHelper';
import { ConditionOperators } from 'src/common/types/graphql.generated';

import { BusinessUnitsTableDataQueryVariables } from '../BusinessUnitsTable.generated';

interface IBusinessUnitsTableParams {
	days: number;
	filters?: IFilterOptions;
}

const HISTORIC_DATE_SAFETY_NET_DAYS = 1;
const CURRENT_DATE_SAFETY_NET_DAYS = 1;
const CURRENT_DATE_OFFSETS = [-CURRENT_DATE_SAFETY_NET_DAYS, 0];
const HISTORIC_DATE_OFFSETS = [
	-CURRENT_DATE_SAFETY_NET_DAYS - HISTORIC_DATE_SAFETY_NET_DAYS,
	-CURRENT_DATE_SAFETY_NET_DAYS,
	-CURRENT_DATE_SAFETY_NET_DAYS + HISTORIC_DATE_SAFETY_NET_DAYS,
	-HISTORIC_DATE_SAFETY_NET_DAYS,
	0,
	HISTORIC_DATE_SAFETY_NET_DAYS
];

const getDateWithOffset = (date: Date, offsetDays: number): string => {
	const result = new Date(date);
	result.setUTCDate(date.getUTCDate() + offsetDays);
	return formatDateForGraphQL(result);
};

export const getCurrentCalculationDateCandidates = (): string[] => {
	const { today: todayDate } = calculateRecentPeriodDates(0);
	return CURRENT_DATE_OFFSETS.map((offset) => getDateWithOffset(todayDate, offset));
};

export const buildBusinessUnitsTableVariables = ({
	days,
	filters
}: IBusinessUnitsTableParams): BusinessUnitsTableDataQueryVariables => {
	const { today: todayDate, recentPeriodStart } = calculateRecentPeriodDates(days);
	const environmentConfig = buildEnvironmentFilters(filters);
	const calculationDates = [
		...HISTORIC_DATE_OFFSETS.map((offset) => getDateWithOffset(recentPeriodStart, offset)),
		...CURRENT_DATE_OFFSETS.map((offset) => getDateWithOffset(todayDate, offset))
	];

	return {
		days,
		calculationDates: {
			operator: ConditionOperators.Any,
			value: [...new Set(calculationDates)]
		},
		...(environmentConfig?.scoreFilter && {
			environmentFilter: environmentConfig.scoreFilter
		})
	};
};
